import { gql } from '@apollo/client';

const ProductionOrderInfoShared = gql`
  fragment ProductionOrderInfoShared on ProductionOrder {
    id
    customerState
    partnerState
    manufacturerState
    hexCode
    importOrderType
    arches
    upperArchQuantity
    lowerArchQuantity
    address
    patientSettings
    sendToClinic
    sentToExternalManufacturer
    sentToExternalManufacturerAt
    projectedDeliveredAt
    manufacturerInProcessAt
    manufacturerOnHoldAt
    manufacturerDiscardAt
    manufacturerInTransitAt
    manufacturerCompletedAt
    legacyId
    manufacturerActivities {
      id
      status
      eventType
      message
      createdAt
    }
    account {
      id
      accountNumber
    }
    patient {
      id
      firstName
      lastName
      dob
      birthDay
      birthMonth
      birthYear
    }
    order {
      id
      hexCode
    }
    partnerLocation {
      id
      name
    }
    referral {
      id
      hexCode
      source
      state
      sentAt
      consumedAt
      createdAt
    }
    user {
      id
      firstName
      lastName
      email
      phone
    }
    disableWarranty
    productionOrderItemsAttributes {
      id
      name
      quantity
      trackingNumber
      eta
      deliveredAt
      trackingUrl
      labelUrl
      manufacturerExternalId
      shippingCarrier {
        id
        name
      }
      shippingCarrierId
      product {
        id
        name
        featuredImage
        warrantyAllowed
      }
      patient {
        id
        firstName
        lastName
        dob
      }
    }
    createdAt
    updatedAt
  }
`;

export default ProductionOrderInfoShared;
